<template>
    <WidgetWrapperComponent
        :class="is_widget_open ? 'widget-full-height' : ''"
        :title="$t('product_report.water_and_solution')"
        id-widget="product-report-water"
        v-on:toggle="is_widget_open = $event"
    >
        <template v-slot:default>
            <v-row class="text-center">
                <v-col cols="12" sm="4">
                    <v-icon color="blue" size="32">mdi-water</v-icon>
                    <p class="font-18 font-weight-bold mb-0">{{ number(totals.water_l) }} L</p>
                    <p class="font-10 font-color-medium mb-0">{{ $t('product_report.water_used_label') }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-icon color="success" size="32">mdi-flask-outline</v-icon>
                    <p class="font-18 font-weight-bold mb-0">{{ number(totals.solution_l) }} L</p>
                    <p class="font-10 font-color-medium mb-0">{{ $t('product_report.solution_produced_label') }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-icon color="blue" size="32">mdi-bottle-tonic-outline</v-icon>
                    <p class="font-18 font-weight-bold mb-0">{{ number(totals.concentrate_l) }} L</p>
                    <p class="font-10 font-color-medium mb-0">{{ $t('product_report.concentrate_used_label') }}</p>
                </v-col>
            </v-row>

            <div class="d-flex gap-2 mt-4 pa-3 report-note">
                <v-icon color="success">mdi-leaf</v-icon>
                <span class="font-12">
                    {{
                        $t('product_report.water_note', {
                            concentrate: number(totals.concentrate_l),
                            solution: number(totals.solution_l),
                            water: number(totals.water_l),
                        })
                    }}
                </span>
            </div>
        </template>
    </WidgetWrapperComponent>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import number from '@/mixin/number'

export default {
    name: 'WaterAndSolutionWidgetComponent',
    components: {
        WidgetWrapperComponent,
    },
    mixins: [number],
    props: {
        totals: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            is_widget_open: true,
        }
    },
}
</script>
